import { useState } from "react";
import { Button, Dialog, Select } from "@jkast90/kast-common/ui";
import styles from "./ClaimDialog.module.css";

const FORM_ID = "move-wish-form";

interface Profile {
  id: number;
  first_name: string;
  last_name: string;
}

interface MoveWishDialogProps {
  open: boolean;
  onClose: () => void;
  onMove: (newWisheeId: number) => void;
  itemDescription: string;
  currentWisheeName: string;
  currentWisheeId: number;
  wishers: Profile[];
}

export default function MoveWishDialog({
  open,
  onClose,
  onMove,
  itemDescription,
  currentWisheeName,
  currentWisheeId,
  wishers,
}: MoveWishDialogProps) {
  const [selectedWisheeId, setSelectedWisheeId] = useState<number | "">("");
  const [missing, setMissing] = useState(false);

  // Clear the choice each time the dialog opens (during render, not in an effect).
  const [wasOpen, setWasOpen] = useState(open);
  if (wasOpen !== open) {
    setWasOpen(open);
    if (open) {
      setSelectedWisheeId("");
      setMissing(false);
    }
  }

  const handleSubmit = (e?: React.FormEvent) => {
    if (e) e.preventDefault();
    if (!selectedWisheeId) {
      setMissing(true);
      return;
    }
    onMove(selectedWisheeId as number);
    setSelectedWisheeId("");
    onClose();
  };

  const handleCancel = () => {
    setSelectedWisheeId("");
    onClose();
  };

  const availableWishers = wishers.filter((w) => w.id !== currentWisheeId);

  return (
    <Dialog
      open={open}
      onClose={handleCancel}
      title="Move Wish"
      footer={
        <>
          <Button onClick={handleCancel}>Cancel</Button>
          <Button variant="primary" type="submit" form={FORM_ID}>
            Move Wish
          </Button>
        </>
      }
    >
      <form id={FORM_ID} onSubmit={handleSubmit}>
        <p className={styles.description}>
          Move: <strong>{itemDescription}</strong>
          <br />
          Currently on <strong>{currentWisheeName}</strong>'s list
        </p>
        <Select
          label="Move to whose wishlist?"
          required
          placeholder="Select a person..."
          options={availableWishers.map((wisher) => ({
            value: String(wisher.id),
            label: `${wisher.first_name} ${wisher.last_name}`,
          }))}
          value={selectedWisheeId === "" ? null : String(selectedWisheeId)}
          onChange={(value) => {
            setMissing(false);
            setSelectedWisheeId(Number(value) || "");
          }}
          hint="This will move the wish item to another family member's wishlist"
          error={
            missing ? "Please select a person to move the wish to" : undefined
          }
        />
      </form>
    </Dialog>
  );
}
